<template>
    <v-card class="mt-4">
        <v-card-title class="subtitle-2 font-weight-bold">
            견적요청업체정보
            <v-spacer />
            <v-btn @click="$emit('show-add')" small color="primary" class="ml-4" :disabled="!isAdmin">업체 추가</v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="interiorsHeaders" :items="interiors" disable-sort disable-pagination hide-default-footer>
                <template v-slot:item.reassurance="{ item }"> {{ item.scope.includes("reassurance") ? "안심" : "일반" }} </template>
                <template v-slot:item.phone="{ item }"> {{ item.phone.phoneNumberFormat() }} </template>
                <template v-slot:item.distance="{ item }"> {{ item.distance !== undefined ? Math.ceil((item.distance || 1) / 1000) + " km" : "-" }} </template>
                <template v-slot:item.portfolios="{ item }">
                    <v-btn :to="`/partners/interior/${item._id}`" target="_blank" text><v-icon>mdi-home</v-icon></v-btn>
                </template>
                <template v-slot:item.lastEstimateAmount="{ item }">
                    <template v-if="item.estimates.length">
                        {{ Math.round(calculateTotalAmount(item.estimates[item.estimates.length - 1])).format() }}
                    </template>
                </template>
                <template v-slot:item.estimates="{ item }">
                    <v-btn v-for="(estimate, i) in item.estimates" :key="`button-${i}`" @click="$emit('showEstimate', estimate)" small color="primary" class="ma-2">견적{{ i + 1 }}차</v-btn>
                </template>
                <template v-slot:item.reRequest="{ item }">
                    <v-btn @click="$emit('clickEstimateRequest', item)" small color="primary">재견적요청</v-btn>
                </template>
                <template v-slot:item.select="{ item }">
                    <v-btn v-if="item.estimates.length" @click="$emit('saveInterior', item)" small color="primary">업체선택</v-btn>
                </template>
            </v-data-table>
            <!-- <v-pagination v-model="page" :length="pageCount" :total-visible="11" class="mt-4 mb-12 mx-4" @input="search"></v-pagination> -->
        </v-card-text>
    </v-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
import { calculateTotalAmount } from "@/plugins/calculateEstimateTotalAmount";

export default {
    components: { viewCard },
    props: {
        interiors: { type: Array, default: () => [] },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            interiorsHeaders: [
                {
                    text: "안심계약",
                    value: "reassurance",
                    width: 65,
                    align: 'center',
                },
                {
                    text: "업체명",
                    value: "meta.companyName",
                    width: 140,
                },
                {
                    text: "대표자",
                    value: "name",
                    width: 80,
                },
                {
                    text: "전화번호",
                    value: "phone",
                    width: 130,
                },
                {
                    text: "거리",
                    value: "distance",
                    width: 80,
                },
                {
                    text: "응답평균시간",
                    value: "averageReplyTime", // todo
                    width: 110,
                },
                {
                    text: "포트폴리오",
                    value: "portfolios",
                    width: 100,
                },
                {
                    text: "진행건수",
                    value: "selectedNumber",
                    width: 65,
                    align: 'center',
                },
                {
                    text: "최종견적금액",
                    value: "lastEstimateAmount",
                    width: 120,
                },
                {
                    text: "답변시간",
                    value: "lastEstimateReplyTime", // todo
                    width: 120,
                },
                {
                    text: "견적서",
                    value: "estimates",
                },
                {
                    text: "재견적요청하기",
                    value: "reRequest", // todo
                    width: 120,
                },
                {
                    text: "업체선택하기",
                    value: "select",
                    width: 120,
                },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,
        };
    },
    methods: {
        calculateTotalAmount,
    },
};
</script>
